import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function home() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">AppDHD</h1>
        <div className="text-gray-700 space-y-4 text-sm leading-relaxed">
          <p className="text-gray-500 italic">Last updated: February 28, 2026</p>
          <p>This application helps with calendar awareness, reminders and notifications. By using this app with your existing calendar application, you can live worry free and make it to your next appointment on time!</p>
          <p><a href='https://appdhd.web.app/terms' className="text-blue-600 hover:underline">Terms & Conditions</a></p>
          <p><a href='https://appdhd.web.app/privacy' className="text-blue-600 hover:underline">Privacy Policy</a></p>
        </div>
      </div>
    </div>
  );
}
